import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  Legend,
} from 'recharts'

interface Series {
  key: string
  label: string
  color?: string
}

interface DataRow {
  name: string
  [key: string]: string | number
}

interface Props {
  data: DataRow[]
  series: Series[]
  height?: number
  yLabel?: string
}

const fmt = (n: number) =>
  n >= 1000 ? `$${Math.round(n / 1000)}k` : `$${n}`

export default function CompareBars({ data, series, height = 320 }: Props) {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={data} margin={{ top: 16, right: 16, bottom: 48, left: 16 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#dcd7cb" />
        <XAxis dataKey="name" tick={{ fontSize: 13, fill: '#5a5a5a', fontWeight: 600 }} />
        <YAxis tickFormatter={fmt} tick={{ fontSize: 11, fill: '#5a5a5a' }} />
        <Tooltip
          formatter={(v) => fmt(Number(v))}
          labelFormatter={(label, payload) => {
            const full = payload?.[0]?.payload?.fullName
            return full || label
          }}
        />
        <Legend
          verticalAlign="bottom"
          wrapperStyle={{ fontSize: 12, paddingTop: 24 }}
        />
        {series.map((s, i) => (
          <Bar
            key={s.key}
            dataKey={s.key}
            name={s.label}
            fill={s.color || (i === 0 ? '#1a1a1a' : '#c9954a')}
            radius={[3, 3, 0, 0]}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  )
}
